module.exports = __webpack_public_path__ + "img/foreground-01-3200x620.9f50b138.png";